import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {ResponsiveNavTabs, ResponsiveNavTab} from "../ResponsiveNavTabs";
import {Login, Logout, ForgotPassword, ReSendEmail, ResetPassword, Signup, VerifyEmail} from "./index";
import {IconTab} from "../_components";
import {useAuth} from "../../context";
import {useBasePath} from "../../hooks";
import {useBrowserTitle} from "../../hooks/useBrowserTitle";

export function RoutesAccount() {
    const path = useBasePath(1)
    useBrowserTitle("Account")

    return <Routes>
        {/* Login and Signup */}
        <Route element={
            <ResponsiveNavTabs>
                <ResponsiveNavTab to={`${path}/login`} icon={<IconTab name="person-fill-check"/>} title="Login"/>
                <ResponsiveNavTab to={`${path}/signup`} icon={<IconTab name="person-fill-add"/>} title="Signup"/>
            </ResponsiveNavTabs>}>

            <Route path="login" element={<Login/>}/>
            <Route path="signup" element={<PublicOnly><Signup/></PublicOnly>}/>
        </Route>

        {/* Very Email (via token) */}
        <Route element={
            <ResponsiveNavTabs>
                <ResponsiveNavTab to={`${path}/verify-email`} icon={<IconTab name="person-fill-up-exclamation"/>} title="Verify EMail"/>
            </ResponsiveNavTabs>}>

            <Route path="verify-email" element={<PublicOnly><VerifyEmail/></PublicOnly>}/>
        </Route>

        {/* Re-Send verification Email (JWT token) */}
        <Route element={
            <ResponsiveNavTabs>
                <ResponsiveNavTab to={`${path}/resend-email`} icon={<IconTab name="person-fill-up"/>} title="Resend Verification Email"/>
            </ResponsiveNavTabs>}>

            <Route path="resend-email" element={<PublicOnly><ReSendEmail/></PublicOnly>}/>
        </Route>

        {/* Forgot Password */}
        <Route element={
            <ResponsiveNavTabs>
                <ResponsiveNavTab to={`${path}/forgot-password`} icon={<IconTab name="person-fill-up-exclamation"/>} title="Forgot Password"/>
            </ResponsiveNavTabs>}>

            <Route path="forgot-password" element={<PublicOnly><ForgotPassword/></PublicOnly>}/>
        </Route>

        {/* Reset Password */}
        <Route element={
            <ResponsiveNavTabs>
                <ResponsiveNavTab to={`${path}/reset-password`} icon={<IconTab name="person-fill-up-exclamation"/>} title="Reset Password"/>
            </ResponsiveNavTabs>}>

            <Route path="reset-password" element={<PublicOnly><ResetPassword/></PublicOnly>}/>
        </Route>

        {/* Logout */}
        <Route path="logout" element={<Logout/>}/>

        <Route path="*" element={<Navigate to={`/account/login`} replace/>}/>
    </Routes>
}

function PublicOnly({children}) {
    const {loggedIn} = useAuth()

    if (loggedIn)
        return <Navigate to="/" replace={true}/>
    return children

}

